import React from 'react'
import AccountTemplate from 'components/templates/AccountTemplate'
import SignUpBox from 'components/organisms/SignUpBox'
import LoginForm from 'containers/organisms/LoginForm'
import LoadingView from 'components/atoms/LoadingView'
import SocialLoginForm from 'components/organisms/SocialLoginForm'
import path from 'routes/path'

export default props => {
  return (
    <AccountTemplate
      title={props.title}
      description={props.description}
      linkCanonical={props.linkCanonical}
      currentUser={props.currentUser}
      breadcrumbs={props.breadcrumbs}
      config={props.config}
    >
      {props.isLoading && <LoadingView />}
      <div className="signup-border lp-page__padding">
        <div className="page__col1">
          <div className="signup-head">
            <h1 className="page-title">{i18n.t('page.shared.l_00015')}</h1>
          </div>
          <div className="signup-box signup-box__line">
            <div className="row col-signup__pd">
              <SocialLoginForm {...props} />
              <div className="col-sm-12 col-md-6 sm-signup-box__line">
                <LoginForm {...props} />
                <div className="ta-c">
                  <p>
                    <a href={path.passwordReset()} className="a__underline">
                      {i18n.t('page.account.l_00019')}
                    </a>
                  </p>
                  <p className="mt10">
                    <a
                      href="https://support.spacemarket.com/ja/articles/4120e6df"
                      rel="noopener noreferrer"
                      target="_blank"
                      className="a__underline"
                    >
                      ログインできない方はこちら
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <SignUpBox {...props} />
        </div>
      </div>
    </AccountTemplate>
  )
}
